import { Typography, Button, SxProps, Theme, Link } from "@mui/material";
import { SectionContainer } from "src/modules/SectionContainer/SectionContainer";

/**
 * Call to Action
 */
export const Cta = () => {
  return (
    <SectionContainer
      sx={{
        background: "linear-gradient(135deg, #28a745, #20c997)",
        color: "white",
        textAlign: "center",
      }}
      contentSx={{
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography variant="h2" sx={ctaTitleSx}>
        クラウド運用の新時代を体験してください
      </Typography>
      <Typography variant="body1" sx={ctaDescriptionSx}>
        従来のMSPでは物足りないと感じるお客様、予測不能なトラブルやビジネス要件の変化に柔軟に対応できるパートナーをお探しのお客様に、テクノスタンダードのAMSPはより高度で包括的なサポートを提供します。
      </Typography>
      <Button variant="contained" sx={ctaButtonSx} component={Link} href="/#Contact">
        無料相談・お問い合わせ
      </Button>
    </SectionContainer>
  );
};

const ctaTitleSx: SxProps<Theme> = {};

const ctaDescriptionSx: SxProps<Theme> = {
  marginBottom: "8px",
  maxWidth: "800px",
  marginLeft: "auto",
  marginRight: "auto",
};

const ctaButtonSx: SxProps<Theme> = {
  width: "fit-content",
  background: "white",
  color: "#28a745",
  padding: "15px 40px",
  borderRadius: "30px",
  fontWeight: 600,
  transition: "all 0.3s ease",
  boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
  "&:hover": {
    transform: "translateY(-3px)",
    boxShadow: "0 12px 25px rgba(0,0,0,0.3)",
    background: "white",
  },
};
